import { Component, OnChanges, Input, HostListener, HostBinding, ElementRef, Output, EventEmitter, inject } from '@angular/core';
import { NavigationStart, Router } from "@angular/router";
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { VDPickerComponent } from '../vd-picker/vd-picker.component';

export type sideMenuItemType = {
  canActivate: boolean;
  id?: string;
  items: sideMenuItemType[];
  opened: boolean;
  title: string;
  class?: string;
  clientOnly?: boolean;
  hasNew?: boolean;
  access?: string;
};

type menuItemType = {
  active: boolean;
  canActivate: boolean;
  id?: string;
  items: menuItemType[];
  opened: boolean;
  title: string;
  class?: string;
  hasNew?: boolean;
};

@Component({
    selector: 'side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    imports: [NgClass, VDPickerComponent, NgStyle, NgTemplateOutlet]
})
export class SideMenuComponent implements OnChanges {
  private router = inject(Router);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input() menuTitle?: string;
  @Input() defaultTitle?: string;
  @Input() items: sideMenuItemType[] = [];
  @Input() isOverViewPage = false;
  @Input() active: unknown;
  @Input() container = '';
  @Input() showVDPicker = false;
  @Output() menuChange : EventEmitter<string>;
  @Output() opened : EventEmitter<string>;
  @Output() dateChange: EventEmitter<string>;
  @HostBinding('class.menuOpened') IsMenuOpened  = false;

  curentItem?: string;
  cssSticky?: boolean;
  fix_menu = false;
  menu_height?: number;
  placeHolder?: null | HTMLElement;
  el?: HTMLElement;
  sticker?: null | HTMLElement;
  menuItems: menuItemType[] = [];

  constructor()
  {
    const router = this.router;

    this.menuChange = new EventEmitter<string>();
    this.opened = new EventEmitter<string>();
    this.dateChange = new EventEmitter<string>();
    router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.closeMenu();
      }
    });
  }

  ngOnChanges() {
    this.el = this.elementRef.nativeElement;
    this.sticker = document.getElementById('side-menu-button');
    this.curentItem = '';
    this.menuItems = this.prepareItems(this.items).items;
  }

  onValuationDateChange(vd: string) {
    this.dateChange.emit(vd);
  }

  prepareItems(items: sideMenuItemType[], path = '') {
    const menuItem: menuItemType = {
      active: false,
      canActivate: false,
      items: [],
      opened: false,
      title: '',
      class: '',
      hasNew: false
    };
    for (const i in items) {
      const id = items[i].id || items[i].id==='' ? items[i].id : i;
      const it: menuItemType = {
        active: id == this.active,
        canActivate: items[i].canActivate,
        id,
        opened: items[i].opened,
        items: [],
        title: items[i].title,
        class: items[i].class,
        hasNew: items[i].hasNew
      };
      if (it.active) this.curentItem = path + (path.length ? ' > ' : '') + it.title;
      if (items[i].items) {
        const sub = this.prepareItems(items[i].items, path + (path.length ? ' > ' : '') + it.title);
        it.items = sub.items;
        it.opened = it.opened || sub.opened;
      }
      menuItem.opened = menuItem.opened || it.opened || it.active;
      menuItem.items.push(it);
    }
    return menuItem;
  }

  groupClicked(selected: menuItemType) {
    if (!selected.canActivate || selected.active) {
      selected.opened = !selected.opened;
    }
    this.opened.emit(selected.id);
  }
  itemClicked(selected: menuItemType) {
    this.menuChange.emit(selected.id);
    this.closeMenu();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.closeMenu();
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (!this.checkCssStisky()) {
      let fix_menu = false;
      if (!window.getComputedStyle(this.el!.parentNode as Element).display.match('none')) {
        this.menu_height = parseInt(window.getComputedStyle(document.getElementsByClassName('content')[0]).paddingTop);
        const height = this.sticker!.getBoundingClientRect().height;
        const c = this.container == '' ? ((this.el!.parentNode as Element).parentNode as Element) : $(this.container)[0];
        const rect = c.getBoundingClientRect();
        if ( rect.top < this.menu_height && rect.bottom > this.menu_height + height) {
          fix_menu = true;
          this.placeHolder!.style.height = height + 'px';
        }
      }
      this.fix_menu = fix_menu;
      if (!fix_menu) {
        this.placeHolder!.style.height = '0';
        this.menu_height = 0;
      }
    }
  }

  closeMenu() {
    this.IsMenuOpened = false;
    //jQuery('body').removeClass('iPadForceMenu'); //fix for old ipads broken position:fixed
    jQuery('body').removeClass('sidemenuOpened');
    if (this.placeHolder) jQuery(this.placeHolder).removeClass('d-none');
  }

  openMenu() {
    this.IsMenuOpened = true;
    //jQuery('body').addClass('iPadForceMenu'); //fix for old ipads broken position:fixed
    jQuery('body').addClass('sidemenuOpened');
    if (this.placeHolder) jQuery(this.placeHolder).addClass('d-none');
  }

  checkCssStisky() {
    if (typeof this.cssSticky == 'undefined' || this.cssSticky == null) {
      const e = document.createElement('DIV');
      e.className = 'sticky-browser-test';
      document.body.appendChild(e);
      this.cssSticky = !!window.getComputedStyle(e).position.match('sticky');
      document.body.removeChild(e);
      if (!this.cssSticky && this.placeHolder == null) {
        this.placeHolder = document.createElement('DIV');
        (this.el!.parentNode as Element).insertBefore(this.placeHolder, this.el!);
      }
    }
    return this.cssSticky;
  }
}
